/* Program Name: WindowContainer.js
 **  Description: container for window content
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200324  2021-08-31  STT  Initial program
 ********************************************************************************/

/**React imports */
import React from 'react'

/**Window CONTAINER */
//A wrapper component for forms in fuji
//  children   = UI     > holds components inside the wrapper to be rendered
const FormContainer = ({ children }) => {
  return (
    <div style={{ paddingTop: 24, display: 'flex' }}>
      <div style={{ flex: 1 }}></div>
      <div style={{ flex: 10 }}>{children}</div>
      <div style={{ flex: 1 }}></div>
    </div>
  )
}

export default FormContainer
